import React, { useEffect, useState } from 'react';
import Cancel from '../../../../Assets/delete.png';
import styles from './Pubslish.module.css';

export const StackedPreview = ({ items, type, setSelectedCheckedItems }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimate(true), 10); // Trigger after mount
    return () => clearTimeout(timer);
  }, []);

  const rotationDegrees = [-8, -4, 0, 4, 8];
console.log('items', items);
  return (
    <div style={{ position: 'relative' }}>
      {items?.length === 1 && type === 'video' ? (
        <div className={styles.videoPlayBox}>
          <button
            className={styles.clearButton}
            onClick={() => setSelectedCheckedItems([])}
          >
            <img src={Cancel} alt="" />
          </button>
          <video
            className={styles.videosetup}
            key={items[0]?.id}
            src={items[0]?.pre_url}
            alt={items[0]?.name}
            poster={items[0]?.pre_thumbnail}
            controls
          >
            Your browser does not support the video tag.
          </video>
        </div>
      ) : (
        <div
          className={`${styles.container} ${
            type === 'photos' ? styles.photoBox : styles.videoBox
          }`}
        >
          {items?.map((item, index) => (
            <img
              key={item.id}
              src={
                type === 'photos'
                  ? item.pre_thumbnail ?? item?.baseUrl
                  : item.pre_thumbnail
              }
              alt={item.name}
              style={{
                position: 'absolute',
                top: index * 1,
                left: index * 2,
                width: '100%',
                height: '100%',
                marginTop: '26px',
                borderRadius: '8px',
                objectFit: 'cover',
                zIndex: index,
                boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                backgroundColor: '#f0f0f0',
                border: '2px solid #ddd',
                transform: animate
                  ? `rotate(${
                      rotationDegrees[index % rotationDegrees.length]
                    }deg) scale(1)`
                  : 'rotate(0deg) scale(0.95)',
                opacity: animate ? 1 : 0,
                transformOrigin: 'center center',
                transition: 'transform 0.5s ease-out, opacity 0.5s ease-out',
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};
